import { useQuery } from "@tanstack/react-query";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import {
  fetchDashboardById,
  getDashboardQueryKey,
  type UseDashboardsOptions,
} from "./utils";

export function useDashboard(
  dashboardId: string | undefined,
  options: UseDashboardsOptions = {}
) {
  const { selectedOrganisation } = useSelectedStores();
  const isEnabled = options.enabled ?? true;

  const query = useQuery({
    queryKey: getDashboardQueryKey(selectedOrganisation, dashboardId),
    queryFn: () =>
      dashboardId && selectedOrganisation
        ? fetchDashboardById(dashboardId, selectedOrganisation)
        : Promise.resolve(null),
    enabled: Boolean(dashboardId && selectedOrganisation && isEnabled),
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });

  return {
    ...query,
    dashboard: query.data ?? null,
    isLoading: query.isLoading,
  };
}
